const getTpoMetricsData = state => state?.tpoRequest?.tpoMetrics
const getTpoUserListData = state => state?.tpoRequest?.tpoUserList

const selectors = {
  getTpoMetricsData,
  getTpoUserListData,
}

export default selectors
